export default __webpack_public_path__ + "static/media/game-start-modal.d99a217c.png";